module.exports = __webpack_public_path__ + "src/assets/models/injection/vials/red_med_vial.fbx";